import { motion } from "framer-motion";
import { MapPin, User, Wallet, ShieldCheck, Calendar } from "lucide-react";

const items = [
  { icon: MapPin,      label: "Aus Karlsruhe",            sub: "Lokal & erreichbar" },
  { icon: User,        label: "Persönliche Betreuung",    sub: "Kein Account-Manager" },
  { icon: Wallet,      label: "Festpreise",               sub: "Keine Überraschungen" },
  { icon: ShieldCheck, label: "DSGVO-konform",            sub: "Hosting in Deutschland" },
  { icon: Calendar,    label: "2 Slots frei ab Juni 2026", sub: "Limitierte Kapazität" },
];

export default function TrustBadges() {
  return (
    <section
      data-testid="trust-badges"
      className="border-y border-zinc-100 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 md:py-7">
        <ul className="grid grid-cols-2 md:grid-cols-5 gap-x-6 gap-y-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.li
                key={it.label}
                initial={{ opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                data-testid={`trust-${i}`}
                className="flex items-center gap-3"
              >
                <div className="shrink-0 w-9 h-9 rounded-xl bg-zinc-50 border border-zinc-100 flex items-center justify-center text-zinc-700">
                  <Icon size={16} strokeWidth={1.6} />
                </div>
                <div className="min-w-0">
                  <div className="text-[13px] font-medium text-zinc-900 leading-tight truncate">
                    {it.label}
                  </div>
                  <div className="text-[11px] text-zinc-500 mt-0.5 leading-tight">
                    {it.sub}
                  </div>
                </div>
              </motion.li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
